export default "__VITE_ASSET__BHR9kyhf__"